import React, { FC, memo } from 'react';
import { Box } from 'entities/Box';
import { ContractInfo } from 'entities/Contract';
import { WarehouseForBooking } from 'entities/Warehouse';
import { ModernSummaryList } from 'widgets/ModernContractInformationForm';
import { ModernPaymentForm } from './ModernPaymentForm';
import { ModernPaymentFormMobile } from './ModernPaymentFormMobile';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

interface ModernPaymentStepProps {
  contractInfo: ContractInfo;
  boxInfo: Nullable<Box>;
  warehouseInfo: Nullable<WarehouseForBooking>;
  onCompleteStep: () => void;
}

export const ModernPaymentStep: FC<ModernPaymentStepProps> = memo((props) => {
  const { boxInfo, warehouseInfo, contractInfo, onCompleteStep } = props;
  const { isDesktop } = useScreenBreakpoints();

  if (isDesktop) {
    return (
      <div className="flex gap-6">
        <div className="flex-1">
          <ModernPaymentForm boxInfo={boxInfo} warehouseInfo={warehouseInfo} contractInfo={contractInfo} onCompleteStep={onCompleteStep} />
        </div>

        <div className="w-[350px] flex-shrink-0">
          <ModernSummaryList warehouseInfo={warehouseInfo} boxInfo={boxInfo} contractOptions={contractInfo} />
        </div>
      </div>
    );
  }

  return (
    <ModernPaymentFormMobile boxInfo={boxInfo} warehouseInfo={warehouseInfo} contractInfo={contractInfo} onCompleteStep={onCompleteStep} />
  );
});
